var React = require('react');

function IconDelivered (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#142B6F","d":"M37.6,36.2l-5.5-2.7V2.9c0-0.6-0.4-1-1-1H8.9c-0.6,0-1,0.4-1,1v30.6l-5.5,2.7c-0.5,0.2-0.7,0.8-0.5,1.3 c0.2,0.4,0.5,0.6,0.9,0.6c0.1,0,0.3,0,0.4-0.1l5.9-2.9h3v1.5c0,0.6,0.4,1,1,1h13.6c0.6,0,1-0.4,1-1v-1.5h3l5.9,2.9 c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.7-0.2,0.9-0.6C38.3,37.1,38.1,36.5,37.6,36.2z M25.8,35.6H14.2v-6.3h11.6V35.6z M30.1,33.1h-2.2 v-4.8c0-0.6-0.4-1-1-1H13.2c-0.6,0-1,0.4-1,1v4.8H9.9V3.9h20.1V33.1z","key":0}),React.createElement("path",{"fill":"#142B6F","d":"M12.8,19.6c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3S12.1,19.6,12.8,19.6z","key":1})]));
}

IconDelivered.defaultProps = {"width":"24","height":"24","x":"0","y":"0","enableBackground":"new 0 0 40 40","version":"1.1","viewBox":"0 0 40 40","xmlSpace":"preserve"};

module.exports = IconDelivered;

IconDelivered.default = IconDelivered;
